import { StatusBarItem, StatusBarTextAndIcon } from '../../shared';
import InterfaceEditWrite2 from '@streamlinehq/streamlinehq/img/streamline-micro-line/interface-essential/edit/interface-edit-write-2.svg';
import { getBouLinkStyle } from '@upright/ui/common/generic/content/texts/bou-link';
import { InternalLink } from '../../../navigation/internal-link';
import styled from 'styled-components';

export function BlanketItem() {
  return (
    <Link key="mapping-blanket-link" to="/blanket/my-product-sets">
      <StatusBarItem>
        <StatusBarTextAndIcon text="Company mapping tool" slIcon={<InterfaceEditWrite2 />} />
      </StatusBarItem>
    </Link>
  );
}

const Link = styled(InternalLink)`
  ${getBouLinkStyle()}
`;
